<template>
  <v-container>
    <v-row class="toolbar-row" align="center" justify="end" no-gutters>
      <v-col cols="12" sm="4" md="3">
        <v-select
          v-model="selectedEstatus"
          :items="estatusPersonal"
          item-text="title"
          item-value="id"
          label="Estatus"
          color="secondary"
          background-color="primary"
          rounded
          filled
          dense
          hide-details
          class="filter-input"
          @change="triggerFetchPersonalPorEstatus"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4" md="3" class="ml-sm-3">
        <v-text-field
          v-model="filtroNombre"
          label="Buscar por nombre..."
          append-icon="mdi-magnify"
          color="secondary"
          background-color="primary"
          rounded
          filled
          dense
          hide-details
          clearable
          class="filter-input"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="filteredPersonal"
          :loading="loading"
          loading-text="Cargando personal..."
          no-data-text="Sin registros"
          class="ui-module-card ui-module-table tabla-personal"
          color="primary"
          :footer-props="{ 'items-per-page-text': 'Filas por página' }"
        >
          <template v-slot:[`item.nombreCompleto`]="{ item }">
            <span class="nombre-text">{{ getNombreCompleto(item) }}</span>
          </template>

          <template v-slot:[`item.CUIP`]="{ item }">
            <span class="cuip-text">{{ item.CUIP || '—' }}</span>
          </template>

          <template v-slot:[`item.puesto`]="{ item }">
            <span class="puesto-text">{{ item.puesto || '—' }}</span>
          </template>

          <template v-slot:[`item.opciones`]="{ item }">
            <div class="actions-row-wrapper">
              <v-tooltip bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="primary secondary--text action-btn ui-module-icon-action"
                    elevation="8"
                    :to="{ name: 'expedientePersonalRH', params: { id: item.idPersonal } }"
                    icon
                    v-on="on"
                    v-bind="attrs"
                    ><v-icon>mdi-file-account</v-icon></v-btn
                  >
                </template>
                <span>Ver expediente</span>
              </v-tooltip>
              <v-tooltip
                bottom
                color="black"
                v-if="hasAccessToFeature(perfil, FEATURES.REGISTRAR_TRAMITE_ADMINISTRATIVO)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="primary secondary--text action-btn ui-module-icon-action"
                    elevation="8"
                    :to="{
                      name: 'recursos_humanos.registro_falta_administrativa',
                      params: { id: item.idPersonal },
                    }"
                    icon
                    v-on="on"
                    v-bind="attrs"
                    ><v-icon>mdi-book-alert</v-icon></v-btn
                  >
                </template>
                <span>Registrar trámite administrativo</span>
              </v-tooltip>
              <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.CAMBIO_DE_ESTATUS)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="primary secondary--text action-btn ui-module-icon-action"
                    elevation="8"
                    :to="{ name: 'actualizaEstatus', params: { id: item.idPersonal } }"
                    icon
                    v-on="on"
                    v-bind="attrs"
                    ><v-icon>mdi-police-badge</v-icon></v-btn
                  >
                </template>
                <span>Cambiar de estatus</span>
              </v-tooltip>
              <v-tooltip
                bottom
                color="black"
                v-if="hasAccessToFeature(perfil, FEATURES.ASIGNACION_PUESTO_FUNCION_ADSCRIPCION)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="primary secondary--text action-btn ui-module-icon-action"
                    elevation="8"
                    :to="{ name: 'asignaSedePersonal', params: { id: item.idPersonal } }"
                    icon
                    v-on="on"
                    v-bind="attrs"
                    ><v-icon>mdi-office-building-marker</v-icon></v-btn
                  >
                </template>
                <span>Asignación de puesto, función y adscripción</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

const EDO_FZA_ID_DEPENDENCIA = 1

export default {
  data() {
    return {
      loading: false,
      filtroNombre: '',
      selectedEstatus: null,
      headers: [
        { text: 'Nombre', value: 'nombreCompleto', sortable: true },
        { text: 'CUIP', value: 'CUIP', sortable: false },
        { text: 'Puesto', value: 'puesto', sortable: false },
        { text: 'Opciones', value: 'opciones', sortable: false, align: 'center' },
      ],
    }
  },

  async mounted() {
    if (this.estatusPersonal.length === 0) {
      await this.fetchEstatusPersonal()
    }

    if (this.estatusPersonal.length > 0) {
      this.selectedEstatus = this.estatusPersonal[0].id
      await this.triggerFetchPersonalPorEstatus()
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('personal', {
      personalPorEstatus: 'getPersonalPorEstatus',
    }),

    ...mapGetters('estatusPersonal', {
      estatusPersonal: 'getEstatusPersonal',
    }),

    filteredPersonal() {
      return this.personalPorEstatus.filter((p) => {
        return !this.filtroNombre || this.getNombreCompleto(p).toLowerCase().includes(this.filtroNombre.toLowerCase())
      })
    },
  },

  methods: {
    ...mapActions('personal', ['fetchPersonalByDependenciaYEstatus']),
    ...mapActions('estatusPersonal', ['fetchEstatusPersonal']),

    getNombreCompleto(personal) {
      return [personal.apaterno, personal.amaterno, personal.nombre, personal.segundoNombre].filter(Boolean).join(' ')
    },

    async triggerFetchPersonalPorEstatus() {
      if (!this.selectedEstatus) return

      this.loading = true
      await this.fetchPersonalByDependenciaYEstatus({
        idDependencia: EDO_FZA_ID_DEPENDENCIA,
        estatus: this.selectedEstatus,
      })
      this.loading = false
    },
  },
}
</script>

<style scoped>
.toolbar-row {
  margin-bottom: 16px;
}

.actions-row-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
}

::v-deep .filter-input .v-input__slot {
  background: rgba(8, 14, 19, 0.52) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 14px !important;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2) !important;
}

::v-deep .filter-input .v-label,
::v-deep .filter-input input,
::v-deep .filter-input .v-icon,
::v-deep .filter-input .v-select__selection {
  color: #e0f0ff !important;
}

::v-deep .filter-input.v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.16) !important;
}

::v-deep .v-btn.primary,
::v-deep .tabla-personal .action-btn {
  background: linear-gradient(135deg, #1a262e 0%, #0f1a1f 100%) !important;
  color: var(--v-secondary-base) !important;
  border: 2px solid rgba(var(--v-secondary-base-rgb), 0.4) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
}
</style>
